import { Link } from 'react-router-dom';
import { Legend } from 'app/components/Legend';
import { Dispatch, SetStateAction, useMemo } from 'react';

import styles from './MapInfo.module.scss';

interface tileSourcesT {
  tileSources: { title: string; url: string }[];
}
interface MapInfoI {
  showLegendState: [boolean, Dispatch<SetStateAction<boolean>>];
}

export const MapInfo = ({ showLegendState }: MapInfoI) => {
  const [showLegend, setShowLegend] = showLegendState;

  const storedMapConfig = localStorage.getItem('selectedMapType');
  const mapDefaultConfig = storedMapConfig
    ? JSON.parse(window._env_[JSON.parse(storedMapConfig).mapname])
    : JSON.parse(window._env_[window._env_.MAP_DEFAULT]);

  const { tileSources }: tileSourcesT = mapDefaultConfig;

  const renderTileSourceLinks = useMemo(() => {
    return tileSources.map((tileSource, index) => (
      <Link className={styles.attribution_link} to={tileSource.url} target="_blank" key={index}>
        &copy; {tileSource.title}
      </Link>
    ));
  }, [mapDefaultConfig.mapname]);

  return (
    <div className={styles.map_info_container}>
      <Legend
        isOpen={showLegend}
        onClick={() => {
          setShowLegend((prev) => !prev);
        }}
      />
      {tileSources && <div className={styles.attribution}>{renderTileSourceLinks}</div>}
    </div>
  );
};
